/**
 * Import lib & config
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * Import components
 *
 */

import { Content__title, Content__subtitle } from "components/content/content";
import { Shadow__separator } from "components/shadow/shadow"; 
/**
 * styled components
 */

const Heading = styled.div`
  margin: 32px 0px;
  ${t.mixins.flex({ direction: "column" })};
  ${t.mixins.sm(`
    margin: 0;
    padding: 0 25px;
    text-align: center;
  `)}
`;

/**
 * A text components
 */

const Content__heading = ({ title, subtitle }) => (
  <Heading>
    <Content__title>{title}</Content__title>
    <Content__subtitle>{subtitle}</Content__subtitle>
    <Shadow__separator />
  </Heading>
);

Content__heading.propTypes = {
  /**
    Heading title
    */
  title: PropTypes.string,
  /**
    Heading title
    */
  subtitle: PropTypes.string,
};

Content__heading.defaultProps = {
  title: "",
  subtitle: "",
};

export default Content__heading;
